










import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: {}
})
export default class NiknevisLogo extends Vue {
  @Prop() logoLabel!: string
  @Prop({ default: 'tes-gold' }) logoColor!: string
  @Prop({ default: 'tes-red' }) logoTextColor!: string
}
